import React, { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import introJs from 'intro.js';
import 'intro.js/introjs.css';

import Layout from '../components/Layout';
import Home from '../components/Home';
import { useTour } from '../provider/TourGuide';
import { HomePage as Tour } from '../enums/tourEnums';
import { useAuth } from '../store/auth.store';
import URLS from '../enums/route';

const HomePage: React.FC = () => {
  const { onExitHome, setEnabledHome } = useTour();
  const { user } = useAuth();
  const location = useLocation();

  useLayoutEffect(() => {
    if (!user) return;
    if (location.pathname !== URLS.HOME.LINK) return;
    if (localStorage.getItem('home')) return;

    if (!localStorage.getItem("catalog")) {
      setEnabledHome(true);
      const intro = introJs()
        .oncomplete(onExitHome)
        .onexit(onExitHome);
  
      intro.setOptions({
            ...Tour,
            scrollToElement: false,     
            disableInteraction: true,  
        });
      intro.start();
    }
  }, []);

  return (
    <Layout>
      <Home.Slider />
      <Home.LastNews />
      <Home.LastOrders />
      <Home.LastServices />
    </Layout>
  );
};

export default HomePage;
